module.exports = __webpack_public_path__ + "img/icon_img_03.4ec2d697.png";